(() => {
  const seen = new WeakSet();
  const init = (scope = document) => scope.querySelectorAll('[data-faogo-drying]').forEach(root => {
    if (seen.has(root)) return;
    seen.add(root);
    const videos = [...root.querySelectorAll('video')];
    const tabs = [...root.querySelectorAll('[data-drying-tab]')];
    const panels = [...root.querySelectorAll('[data-drying-panel]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 700px)');
    let visible = false;
    const isActive = index => !mobile.matches || panels[index]?.classList.contains('is-current');
    const pauseAll = () => videos.forEach(video => video.pause());
    const play = (video, index) => {
      if (!visible || !isActive(index) || reducedMotion.matches) return;
      video.muted = true;
      video.play().then(() => {
        if (!visible || !isActive(index) || reducedMotion.matches) video.pause();
      }).catch(() => {});
    };
    const playVisible = () => videos.forEach((video, index) => play(video, index));
    const activate = index => {
      tabs.forEach((tab, i) => tab.setAttribute('aria-selected', String(i === index)));
      panels.forEach((panel, i) => panel.classList.toggle('is-current', i === index));
      videos.forEach((video, i) => { if (mobile.matches && i !== index) video.pause(); });
      if (visible && !reducedMotion.matches) playVisible();
    };
    tabs.forEach((tab, index) => tab.addEventListener('click', () => activate(index)));
    videos.forEach((video, index) => {
      video.controls = false;
      video.muted = true;
      video.addEventListener('play', () => { video.muted = true; });
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (!visible) pauseAll();
        else if (!reducedMotion.matches) playVisible();
      }, { threshold: 0.25 });
      observer.observe(root);
    }
    reducedMotion.addEventListener?.('change', () => {
      if (reducedMotion.matches) {
        pauseAll();
        videos.forEach(video => video.load());
      }
      else if (visible) playVisible();
    });
    mobile.addEventListener?.('change', () => { pauseAll(); if (visible && !reducedMotion.matches) playVisible(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
